import { dimensionSlugs } from '@features/reports';
import { z } from 'zod';
import { TOP_BOTTOM_NAMES } from '../slides/overview-slide-interface';
import { youtubeImpressionsSchema } from '@features/reports/subdomains/visitation';

export const formSchema = (totalImpressions: number) =>
  z.object({
    campaignName: z.string(),
    ftaSummary: z.string(),
    rsaSummary: z.string(),
    ftaOverallResults: z.string(),
    rsaOverallResults: z.string(),
    cmOverall: z.string(),
    cmInStore: z.string(),
    cmOnline: z.string(),
    rsaSummaryTable: z.string(),
    youtubeImpressions: youtubeImpressionsSchema(totalImpressions),
    includedSlidesPreset: z.enum(['default', 'lciBrief']),
    includedSlides: z.object({
      overall: z.object({
        overview: z.boolean(),
        executiveSummary: z.boolean(),
      }),
      footTraffic: z.object({
        titleSlide: z.boolean(),
        overallResults: z.boolean(),
        optimizationIndex: z.boolean(),
        dimensions: z.boolean(),
      }),
      salesAttribution: z.object({
        titleSlide: z.boolean(),
        summary: z.boolean(),
        contributionMetrics: z.boolean(),
        summaryTable: z.boolean(),
        dimensions: z.boolean(),
      }),
      campaignAnalytics: z.object({
        titleSlide: z.boolean(),
        audienceProfile: z.boolean(),
        demographicProfile: z.boolean(),
        stateAndDmaVisits: z.boolean(),
        brandLocationVisits: z.boolean(),
        proximityToHome: z.boolean(),
        timeToFirstVisitByDay: z.boolean(),
        visitsByHourOfDay: z.boolean(),
        visitsByDayOfWeek: z.boolean(),
        footTrafficOverlap: z.boolean(),
      }),
      appendix: z.boolean(),
    }),
    dimensions: z.record(
      z.enum([...dimensionSlugs, ...TOP_BOTTOM_NAMES]),
      z.object({
        visitsTableHeader: z.string(),
        salesTableHeader: z.string(),
        checkbox: z.boolean(),
      })
    ),
  });

export type FormSchema = z.infer<ReturnType<typeof formSchema>>;
